var I = /* @__PURE__ */ ((E) => (E[E.DELIVERY = 1] = "DELIVERY", E[E.TAKEAWAY = 2] = "TAKEAWAY", E[E.DINEIN = 3] = "DINEIN", E[E.BOOKING = 4] = "BOOKING", E))(I || {});
export {
  I as TicketServiceType
};
//# sourceMappingURL=ticketServiceType.js.map
